import { map } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { RentalObjectCategory } from '../../model/const/enums';
import { VacantRentalObjectService } from './../data/vacant-period.service';
import { rentalObjectFormCommand } from '../../model/const/command';
import { MessageService } from '../../../core/service/message.service';
import { AppendixService } from '../data/appendix.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { appendixCommand } from '../../command/appendix.command';

@Injectable()
export class PreviewAppendixCommandHandler implements ICommandHandler {
  constructor(
    private _service: AppendixService,
    private _messageService: MessageService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: Command): boolean {
    return command.id === appendixCommand.previewAppendix && command.context;
  }

  execute(command: Command): Observable<void> {
    if (command instanceof Command) {
      return this._service.preview(command.context.id).pipe(
        map(
          res => this._nativeWindow.openFile(res),
          error => this._messageService.showError(error)
        )
      );
    }
  }
}
